import { Flex, Text } from "@chakra-ui/react";

export function TabDesk({ children }) {
  return (
    <Flex direction="column" width="100%">
      <Flex borderBottom="1px dashed #c3c3c3" mt={"10px"} mb={"5px"}>
        <Flex w={"22%"}>
          <Text fontSize={"h4"}>Número do Pedido</Text>
        </Flex>
        <Flex w={"37%"}>
          <Text fontSize={"h4"}>Itens</Text>
        </Flex>
        <Flex>
          <Text fontSize={"h4"}>Status</Text>
        </Flex>
      </Flex>
      <Flex direction="column" width="100%">
        {children}
      </Flex>
    </Flex>
  );
}
